<template>
  <v-app>
    <app-bar :is-mobile="isMobile" />
    <menu-dialog />
    <div
      style="padding-top: 75px; background: #fff; min-height: calc(100vh-300)"
    >
      <router-view
        :is-mobile="isMobile"
        :authenticated="authenticated"
        @handleError="handleError"
        @refreshUser="refreshUser"
      />
    </div>
    <footer-bar :is-mobile="isMobile" />
    <general-error-alert
      v-if="error"
      v-model="errorDialog"
      :title="error.title"
      :message="error.message"
    />
  </v-app>
</template>

<script>
  import { detectMobile } from '@/lib/CheckDesktop';
  import Firebase from '@/lib/firebase';
  import { onAuthStateChanged } from 'firebase/auth';
  import AuthenticationManager from '@/controllers/AuthenticationManager';
  import { mapState, mapActions } from 'vuex';
  import CollectiblesController from '@/controllers/CollectiblesController';

  export default {
    name: 'Home',

    components: {
      FooterBar: () => import('./components/FooterBar.vue'),
      GeneralErrorAlert: () => import('./components/GeneralErrorAlert.vue'),
      AppBar: () => import('./components/AppBar.vue'),
      MenuDialog: () => import('./components/MenuDialog.vue'),
    },

    data: () => ({
      authenticated: false,
      error: null,
      errorDialog: false,
      errorMessage: null,
    }),

    computed: {
      ...mapState({
        user: (state) => state.user,
        tokens: (state) => state.tokens,
      }),
      isMobile() {
        var mobile = detectMobile();
        return mobile || this.$vuetify.breakpoint.smAndDown;
      },
    },

    watch: {
      user(val) {
        if (val) {
          this.authenticated = true;
          this.getTokens();
        } else {
          this.authenticated = false;
        }
      },
    },

    mounted() {
      onAuthStateChanged(Firebase.auth, (user) => {
        if (user) {
          if (this.$route.name !== 'Authentication') {
            this.userUpdated(user);
          }
        } else {
          this.userUpdated(null);
        }
      });

      if (!this.tokens || this.tokens.length == 0) {
        this.getTokens();
      }
    },

    methods: {
      ...mapActions({ setUser: 'setUser', setTokens: 'setTokens' }),
      getTokens: async function() {
        if (this.user) {
          const tokens = await CollectiblesController.getTokens();
          this.setTokens(tokens);
        }
      },

      async refreshUser() {
        const user = Firebase.auth.currentUser;
        if (user) {
          this.userUpdated(user);
        }
      },

      async userUpdated(firebaseUser) {
        if (!firebaseUser) {
          this.firebaseToken = null;
          this.setUser(null);
          this.setTokens(null);
          return;
        }
        this.firebaseToken = await firebaseUser.getIdToken();
        const user = await AuthenticationManager.authenticate(
          this.firebaseToken
        );
        this.setUser(user);
      },

      handleError(error) {
        this.error = error;
        this.errorMessage = error.message;
        this.errorDialog = true;
      },
    },
  };
</script>

<style scoped></style>
